import { render, staticRenderFns } from "./customer-picker.vue?vue&type=template&id=70f0b48b"
import script from "./customer-picker.vue?vue&type=script&lang=js"
export * from "./customer-picker.vue?vue&type=script&lang=js"
import style0 from "./customer-picker.vue?vue&type=style&index=0&id=70f0b48b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports